module.exports = __webpack_public_path__ + "img/288415570.d8e55ed1.jpg";